



































import Vue from 'vue'
import CardItem from '@/magazine/components/CardItem.vue'
import Pagination from '@/common/components/Pagination.vue'
import { getMagazineAllTypeDetail } from '@/magazine/services'
import { MagazineCard } from '@/magazine/types'
import {
  MAGAZINE_TYPE_BASE_URLS,
  MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPE_ITEMS,
  MAGAZINE_TYPES,
  CMS_CATEGORY_URL_QUERY,
  MAX_NUMBER_OF_DISPLAY_PAGES
} from '@/magazine/consts'
import { SYSTEM_ERROR } from '@/common/constants'

export default Vue.extend({
  components: {
    CardItem,
    Pagination
  },
   data(): {
    magazineCard: MagazineCard[] | [],
    itemType: string,
    itemOffset: number,
    itemLimit: number,
    itemTotalCount: number,
    itemPage: number
  } {
    return {
      magazineCard: [],
      itemType: '',
      itemOffset: 0,
      itemLimit: MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPE_ITEMS,
      itemTotalCount: 0,
      itemPage: 1
    }
  },
  computed: {
    urlPathSlug(): string  {
      return this.$route.params.magazineType
    },
    columnBaseUrl(): string {
      return MAGAZINE_TYPE_BASE_URLS.COLUMN
    },
    featureBaseUrl(): string {
      return MAGAZINE_TYPE_BASE_URLS.FEATURE
    },
    magazineType() {
      let itemBaseUrl = ''
      let itemTitle = ''
      switch (this.urlPathSlug) {
        case MAGAZINE_TYPES.COLUMN:
          itemBaseUrl = this.columnBaseUrl
          itemTitle = 'コラム・制作のコツ'
          break
        case MAGAZINE_TYPES.FEATURE:
          itemBaseUrl = this.featureBaseUrl
          itemTitle = '特集・キャンペーン一覧'
          break
        case MAGAZINE_TYPES.CATEGORY:
          itemBaseUrl = MAGAZINE_TYPE_BASE_URLS.CATEGORY
          itemTitle = '商品特集ページ一覧'
          break
      }
      return {
        itemBaseUrl: itemBaseUrl,
        itemTitle: itemTitle
      }
    },
    paginationOptions(): {
      showPagination: boolean
      numberOfItemsPerPage: number
      maxNumberOfDisplayPages: number
      totalNumberOfItems: number
    } {
      return {
        showPagination: this.itemTotalCount > this.itemLimit,
        numberOfItemsPerPage: this.itemLimit,
        maxNumberOfDisplayPages: MAX_NUMBER_OF_DISPLAY_PAGES,
        totalNumberOfItems: this.itemTotalCount
      }
    },
    urlQueries(): {[key: string]: string} | undefined {
      if (MAGAZINE_TYPES.CATEGORY === this.itemType) return CMS_CATEGORY_URL_QUERY
      return undefined
    }
  },
  created() {
    const urlPageValue = Number(this.$route.query.page)
    this.itemPage = (urlPageValue || urlPageValue > 0) ? urlPageValue : 1
    this.itemType = this.urlPathSlug
    this.updateRouterPage(this.itemPage)
    this.getMagazineItems()
  },
  methods: {
    async getMagazineItems() {
      this.itemOffset = 0
      if (this.itemPage != 1) {
        this.itemOffset = (this.itemPage * this.itemLimit) - this.itemLimit
      }
      const { data } = await getMagazineAllTypeDetail(this.itemType, this.itemOffset, this.itemLimit).catch(() => alert(SYSTEM_ERROR.UNKNOWN))
      if (data) {
        this.magazineCard = this.itemType === MAGAZINE_TYPES.CATEGORY ? data?.cmsCategories?.items : data?.cmsMagazines?.items
        this.itemTotalCount = data?.cmsCategories?.totalItemsCount || data?.cmsMagazines?.totalItemsCount
      }
    },
    selectPageHandler(pageNumber: number) {
      this.itemPage = pageNumber
      this.updateRouterPage(pageNumber)
      this.getMagazineItems()
    },
    updateRouterPage(pageNumber: number){
      this.$router.push({query: {page: pageNumber.toString()}})
    }
  }
})
